module.exports = __webpack_public_path__ + "media/images/emblems/GW-TG-Kemmental-789afcbf7e6a6fbf2c189e887d485fae.png";